import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import Login from "./Firebase/Login"
import UserOrders from "./Component/userOrders"
import UserQuotations from "./Component/userQuotations"
import Dashboard from "./Dashboard"
import UserQueries from "./Component/userQueries"
import UserNegotiations from "./Component/userNegotiations"
import AltAlarm from "./Component/altAlarm"
import SupplierProfile from "./Firebase/supplierProfile"
import Notification from "./Component/notifications"
import RaisedIssues from "./Component/raisedIssue"
import NewOffers from "./Component/newOffers"
import ProtectedRoute from "./Firebase/ProtectedRoute"
import BrandRates from "./Component/brandRates"
import StockAvailability from "./Component/stockAvailability"
import ProductOffers from "./Component/productOffer"
import TransportGoodsReply from "./Component/transport-goods-reply"
import AdminLogin from "./Component/admin-login"
import AdminDashboard from "./Component/admin-dashboard"
import AdminProtectedRoute from "./Component/AdminProtectedRoute"
// import ForgotPassword from "./Firebase/forgotPassword"
import ContactSupport from "./Firebase/contactSupport"
import Finance from "./Component/finance"
import AccountDetails from "./Component/accountDetails"
import ClientRecords from "./Component/client-records/clientRecords"
import SessionExpiredWrapper from "./Component/SessionExpiredWrapper"
import BroadcastingPage from "./Component/broadcast"
import SupplierChatbot from "./Component/chatbot"
// import SteelOrders from "./Component/steelOrders"
// import MachineryOrders from "./Component/machineryOrders"
import ClientDetails from "./Component/admin-components/clientsOverview"
import GlobalNotificationListener from "./Component/globalNotificationListener"
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Support from "./Component/support"

function App() {

  
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        {/* <Route path="/forgot-password" element={<ForgotPassword />} /> */}
        <Route path="/contact-support" element={<ContactSupport />} />
        <Route path="/" element={<Login />} />

        {/* Supplier Routes */}
        <Route path="/dashboard" element={<ProtectedRoute element={<Dashboard />} />} />
        <Route path="/UserOrders" element={<ProtectedRoute element={<UserOrders />} />} />
        <Route path="/userQuotations" element={<ProtectedRoute element={<UserQuotations />} />} />
        <Route path="/userQueries" element={<ProtectedRoute element={<UserQueries />} />} />
        <Route path="/userNegotiations" element={<ProtectedRoute element={<UserNegotiations />} />} />
        <Route path="/altAlarm" element={<ProtectedRoute element={<AltAlarm />} />} />
        <Route path="/profile" element={<ProtectedRoute element={<SupplierProfile />} />} />
        <Route path="/notifications" element={<ProtectedRoute element={<Notification />} />} />
        <Route path="/raisedIssue" element={<ProtectedRoute element={<RaisedIssues />} />} />
        <Route path="/newOffers" element={<ProtectedRoute element={<NewOffers />} />} />
        <Route path="/brandRates" element={<ProtectedRoute element={<BrandRates />} />} />
        <Route path="/finance" element={<ProtectedRoute element={<Finance />} />} />
        <Route path="/stockAvailability" element={<ProtectedRoute element={<StockAvailability />} />} />
        <Route path="/productOffer" element={<ProtectedRoute element={<ProductOffers />} />} />
        <Route path="/accountDetails" element={<ProtectedRoute element={<AccountDetails />} />} />
        <Route path="/clientRecords" element={<ProtectedRoute element={<ClientRecords />} />} />
        <Route path="/broadcast" element={<ProtectedRoute element={<BroadcastingPage />} />} />
        <Route path="/chatbot" element={<ProtectedRoute element={<SupplierChatbot />} />} />
         <Route path="/support" element={<ProtectedRoute element={<Support />} />}/>
        {/* <Route path="/steelOrders" element={<ProtectedRoute element={<SteelOrders />} />} />
        <Route path="/machineryOrders" element={<ProtectedRoute element={<MachineryOrders />} />} /> */}
        <Route path="/transport-goods-reply" element={<ProtectedRoute element={<TransportGoodsReply />} />} />
        <Route path="/admin/clientsOverview" element={<ProtectedRoute element={<ClientDetails />} />}/>


        {/* Admin Routes */}
        <Route path="/admin-dashboard/*" element={<AdminProtectedRoute element={<AdminDashboard />} />} />
      </Routes>
      <SessionExpiredWrapper/>
       <GlobalNotificationListener />
       <ToastContainer position="top-right" autoClose={5000} />
    </Router>
  )
}

export default App;

